import { render, staticRenderFns } from "./SuricataAlertDetails.vue?vue&type=template&id=21a18035&scoped=true&"
import script from "./SuricataAlertDetails.vue?vue&type=script&lang=js&"
export * from "./SuricataAlertDetails.vue?vue&type=script&lang=js&"
import style0 from "./SuricataAlertDetails.vue?vue&type=style&index=0&id=21a18035&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a18035",
  null
  
)

export default component.exports